import doRequest from '@/api/dssRequest';
import { translate } from '@/translation/native_translate';
import utility, { toCurrency } from '@/shared/utility';

export default class DeliveryFee {
  // eventId = '';
  //
  // deliveryPossible = false;
  // name = '';
  // note = '';
  // price = 0.0;
  //
  // requestSuccess = false;
  // resultSet = {
  //   currentOrderValue: 0.0,
  //   discount: 0,
  //   improvements: [],
  //   price: 0.0,
  //   reasons: [],
  //   vatPercentage: 0,
  //   vatPrice: 0.0,
  // };

  getDeliveryFee(shoppingList) {
    if (
      shoppingList == null ||
      shoppingList.Temporary ||
      (shoppingList.SubEventType !== 'Delivery' &&
        shoppingList.SubEventType !== 'Shiplee')
    ) {
      if (shoppingList != null) {
        shoppingList.DeliveryFee = {};
        shoppingList.DeliveryDetails = {};
      }
      return;
    }
    const payload = {
      PostalCode: shoppingList.PostalCode,
      CountryCode: shoppingList.Country,
      ShoppingListId: shoppingList.ShoppingListId,
    };

    return new Promise((resolve, reject) => {
      doRequest(
        (response) => {
          resolve(response);
        },
        (error) => {
          reject(error);
        },
        'getDeliveryFee',
        shoppingList.SubEventId,
        payload
      );
    });
  }
}
